var _Path, _Path2, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgAppStore = function SvgAppStore(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M18.231 0c2.8 0 4.2 0 5.725.467a5.886 5.886 0 0 1 3.546 3.546C28 5.538 28 6.97 28 9.77v8.462c0 2.8 0 4.2-.467 5.725a5.886 5.886 0 0 1-3.546 3.546C22.43 28 21.03 28 18.23 28H9.77c-2.8 0-4.2 0-5.725-.467a5.985 5.985 0 0 1-3.577-3.577C0 22.462 0 21.062 0 18.23V9.77c0-2.8 0-4.2.467-5.725C1.089 2.396 2.364 1.09 4.044.498 5.538 0 6.938 0 9.77 0h8.462Z",
    fill: "url(#paint0_linear)"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.862 18.48c0-.871-.435-1.649-1.12-2.053-.062-.031-.124-.063-.218-.063h-4.169l5.351-9.115c.374-.622.25-1.431-.342-1.836-.653-.466-1.555-.249-1.96.436l-.373.622-.342-.591c-.374-.591-1.12-.871-1.774-.591a1.326 1.326 0 0 0-.622 1.898l1.151 1.96-4.2 7.217h-3.08c-.715 0-1.337.498-1.4 1.214-.093.809.56 1.493 1.338 1.493h11.604c.032 0 .094-.031.094-.062l.012-.07c.026-.157.05-.296.05-.459Zm6.036-2.116c.715 0 1.337.53 1.4 1.214.062.809-.56 1.493-1.338 1.493h-1.65l1.214 2.085c.342.59.218 1.4-.342 1.804-.249.187-.529.28-.809.28a1.37 1.37 0 0 1-1.182-.684l-2.924-5.072-2.303-3.982c-.03-.03-.03-.062-.03-.124 0-.078-.009-.156-.016-.234a2.34 2.34 0 0 1-.016-.233c0-1.089.249-2.178.747-3.049.062-.093.218-.093.28 0l3.795 6.471h3.174v.031Zm-16.583 3.33c.031-.063.094-.094.156-.125.249-.062.498-.125.747-.125a2.71 2.71 0 0 1 1.804.685.192.192 0 0 1 .031.218l-1.275 2.177a1.37 1.37 0 0 1-1.183.685c-.28 0-.56-.093-.808-.28-.56-.405-.685-1.213-.343-1.805l.871-1.43Z",
    fill: "white"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear",
    x1: 0,
    y1: 0.009,
    x2: 0,
    y2: 27.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#19E6FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#1E51EE"
  })))));
};
export default SvgAppStore;